<div class="mb-5">
    <a routerLink="/sistemerp/proiecte/lista" class="btn btn-primary font-weight-bold text-uppercase px-9 py-4">
        <i class="icofont-arrow-left"></i> Inapoi la proiecte
    </a>
</div>
<div class="card card-custom gutter-b" xmlns="http://www.w3.org/1999/html">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Vizualizare proiect - {{projectData.projectNumber}}</h3>
        </div>
    </div>
    <div class="card-body">
        <!--begin: Wizard -->
        <div
            #wizard
            class="wizard wizard-4"
            data-wizard-state="step-first"
            id="kt_wizard_v4"
        >
            <!--begin: Form Wizard Nav -->
            <div class="wizard-nav">
                <div class="wizard-steps">
                    <a
                            class="wizard-step"
                            data-wizard-state="current"
                            data-wizard-type="step"
                            href="javascript:;"
                    >
                        <div class="wizard-wrapper">
                            <div class="wizard-number">1</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Date de identificare</div>
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">2</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Detalii Job</div>
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">3</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Cerinte Job</div>
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">4</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Recrutare</div>
                            </div>
                        </div>
                    </a>
                    <a class="wizard-step" data-wizard-type="step" href="javascript:;">
                        <div class="wizard-wrapper">
                            <div class="wizard-number">5</div>
                            <div class="wizard-label">
                                <div class="wizard-title">Buget</div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <!--end: Form Wizard Nav -->

            <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                    <div class="row justify-content-center pt-10">
                        <div class="col-xl-12">
                            <!--begin: Form Wizard Form-->
                            <form #createProject="ngForm" class="form mt-0 mt-lg-10">
                                <!--begin: Form Wizard Step 1-->
                                <div
                                        class="pb-5"
                                        data-wizard-state="current"
                                        data-wizard-type="step-content"
                                >
                                    <div class="row mb-10">
                                        <div class="col-md-12">
                                            <h3>
                                                Date identificare interne ABJ
                                            </h3>
                                            <div>
                                                <p>Nume proiect: {{projectData.name}}</p>
                                                <p>Client: {{projectData.clientName}}</p>
                                                <p>Nr. Contract: {{projectData.contract}}</p>
                                                <p>Nr. Factura: {{projectData.fiscalBill}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Responsabil ABJ cont alocat - Manager de proiect</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Nume: {{projectData.projectManagerName}} {{projectData.projectManagerLastName}}</p>
                                                <p>Branch alocat: {{projectData.projectManagerBranch}}</p>
                                                <p>Email: {{projectData.projectManagerEmail}}</p>
                                                <p>Telefon: {{projectData.projectManagerTelephone}}</p>
                                                <p>Nivel: {{projectData.projectManagerLevel}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Responsabil ABJ cont alocat - Recrutor</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Nume: {{projectData.recruiterFirstName}} {{projectData.recruiterLastName}}</p>
                                                <p>Branch alocat: {{projectData.recruiterBranch}}</p>
                                                <p>Email: {{projectData.recruiterEmail}}</p>
                                                <p>Telefon: {{projectData.recruiterTelephone}}</p>
                                                <p>Nivel: {{projectData.recruiterLevel}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <h3>Responsabil direct de la client (Managerul)</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Nume: {{projectData.managerName}}</p>
                                                <p>Telefon: {{projectData.managerTelephone}}</p>
                                                <p>Email: {{projectData.managerEmail}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Wizard Step 1-->

                                <!--begin: Form Wizard Step 2-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <h3>Detalii job</h3>
                                    <div class="row mb-10">
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Companie angajatoare: {{projectData.employingCompany}}</p>
                                                <p>Denumire post: {{projectData.jobName}}</p>
                                                <p>Numar de posturi: {{projectData.numberAvailableJobs}}</p>
                                                <p>Tara locatie post: {{projectData.jobCountry}}</p>
                                                <p>Judet locatie post: {{projectData.jobCities}}</p>
                                                <p>Nivel post: {{projectData.levelJob | enumTransform}}</p>
                                                <p>Tip post: {{projectData.jobType | enumTransform}}</p>
                                                <p>Tip contract: {{projectData.contractType}}</p>
                                                <p>Disponibilitate post: {{projectData.jobAvailability | enumTransform}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Sectiune Management</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Nume manager direct: {{projectData.directManagerName}}</p>
                                                <p>Telefon manager direct: {{projectData.directManagerTelephone}}</p>
                                                <p>Email manager direct: {{projectData.directManagerEmail}}</p>
                                                <p>Team manager: {{projectData.teamManager | enumTransform}}</p>
                                                <p>Posibilitati de cariera: <span *ngFor="let careerPosib of projectData.careerPossibility">{{careerPosib | enumTransform}}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Pachet salarial</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Salariu fix: {{projectData.fixedSalary}}</p>
                                                <p>Bonus: {{projectData.bonus | enumTransform}}</p>
                                                <p>Valoare medie bonus: {{projectData.averageBonusValue}}</p>
                                                <p>Alte beneficii: {{projectData.otherBenefit}}</p>
                                                <p>Nevoie relocare: {{projectData.relocation | enumTransform}}</p>
                                                <p>Prima relocare: {{projectData.premiumRelocation | enumTransform}}</p>
                                                <p>Locuinta relocare: {{projectData.relocationHouse}}</p>
                                                <p>Instrumente de lucru: {{projectData.workingTools}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12"><h2>Conditii contractuale agentia ABJ</h2></div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Durata de implementare: {{projectData.implementationDuration}}</p>
                                                <p>Numar de candidati propusi: {{projectData.numberCandidates}}</p>
                                                <p>Perioada de garantie: {{projectData.warrantyPeriod}}</p>
                                                <p>Perioada de proba client: {{projectData.probationPeriod}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h2>Evaluare interna ABJ</h2>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Nivel de dificultate: {{projectData.levelDifficulty}}</p>
                                                <p>Numar de credite deblocare CVs acordate: {{projectData.numberCredits}}</p>
                                                <p>Buget implementare proiect: {{projectData.projectImplementationBudget}}</p>
                                                <p>Proiecte similare: {{projectData.similarProjects}}</p>
                                                <p>Responsabil implementare proiecte similare: {{selectedRecrut}}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <!--end: Form Wizard Step 2-->

                                <!--begin: Form Wizard Step 3-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <h3>
                                        Profil Job - Cerinte
                                    </h3>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <div>
                                                <p>Scopul postului: {{projectData.jobPurpose}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Valori</h3>
                                        </div>
                                        <div class="col-xl-12">
                                                <div *ngFor="let companyValue of projectData.companyValues">
                                                    <hr>
                                                    <p>Nume: {{companyValue.name}}</p>
                                                    <p>Descriere: {{companyValue.description}}</p>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Responsabilitati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div *ngFor="let responsibility of projectData.responsibility">
                                                <hr>
                                                <p>Nume: {{responsibility.name}}</p>
                                                <p>Descriere: {{responsibility.description}}</p>
                                                <p>Importanta: {{responsibility.importance}}</p>
                                                <p>Procent de timp: {{responsibility.timePercentage}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Abilitati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div *ngFor="let skillRequired of projectData.skillRequired">
                                                <hr>
                                                <p>Nume: {{skillRequired.abilityName}}</p>
                                                <p>Descriere: {{skillRequired.abilityDescription}}</p>
                                                <p>Nivel: {{skillRequired.abilityLevel}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Studii</h3>
                                        </div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Studii generale: {{projectData.generalStudies | enumTransform}}</p>
                                                <p>Studii de specialitate: {{projectData.specializedStudies}}</p>
                                                <p>Alte studii: {{projectData.otherStudies}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Testari</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Testari tehnice</h5>
                                            <div *ngFor="let technicalTesting of projectData.technicalTesting">
                                                <hr>
                                                <p>Nume: {{technicalTesting.name}}</p>
                                                <p>Nivel: {{technicalTesting.level}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Testari psihologice</h5>
                                            <div *ngFor="let psychologicalTesting of projectData.psychologicalTesting">
                                                <hr>
                                                <p>Nume: {{psychologicalTesting.name}}</p>
                                                <p>Nivel: {{psychologicalTesting.level}}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Calificari / Certificari</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Limbi straine</h5>
                                            <div *ngFor="let foreignLanguage of projectData.foreignLanguage">
                                                <hr>
                                                <p>Limba: {{foreignLanguage.language}}</p>
                                                <p>Nivel: {{foreignLanguage.level}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <hr>
                                            <p>Certificari personale: {{projectData.professionalCertifications}}</p>
                                            <p>Permis de conducere: {{projectData.driverLicense}}</p>

                                        </div>
                                    </div>


                                    <div class="row mb-10">
                                        <div class="col-lg-12"><h3>Experienta</h3></div>
                                        <div class="col-xl-6">
                                            <div class="form-group">
                                                <p>Nivel total experienta in munca: {{projectData.totalLevelWorkExperience}}</p>
                                                <p>Nivel experienta in munca in domeniul specificat: {{projectData.levelWorkExperienceInSimilarActivitySector}}</p>
                                                <p>Nivel experienta in munca in subdomeniul specificat: {{projectData.levelWorkExperienceInSimilarActivitySubSector}}</p>
                                                <p>Nivel experienta in munca in departamentul specificat: {{projectData.levelWorkExperienceInSimilarDepartment}}</p>
                                                <p>Nivel experienta in munca pe o pozitie similara: {{projectData.levelWorkExperienceInSimilarPosition}}</p>
                                                <p>Software specific activitatii desfasurate: {{projectData.specificSoftwareForActivityPerformed}}</p>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-lg-12"><h3>Conditii de lucru specifice</h3></div>
                                        <div class="col-xl-6">
                                            <div>
                                                <p>Program de lucru: {{projectData.workProgram | enumTransform}}</p>
                                                <p>Spatiu de lucru: {{projectData.workSpace}}</p>
                                                <p>Disponibilitate efort fizic: {{projectData.physicalEffortAvailability | enumTransform}}</p>
                                                <p>Detalii efort fizic: {{projectData.physicalEffortDetail}}</p>
                                                <p>Interval varsta ideala: {{projectData.idealAge}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Wizard Step 3-->

                                <!--begin: Form Wizard Step 4-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <div class="col-lg-12"><h3>Etape de recrutare</h3></div>
                                    <mat-vertical-stepper #stepper>
                                        <mat-step *ngFor="let recStep of projectData.recruitmentStage; index as i;"
                                                  id="stepgroup" label="{{recStep.name}}">
                                            <div>
                                                <p>Data de start: {{recStep.startDate}}</p>
                                                <p>Deadline: {{recStep.deadLine}}</p>
                                                <p>Durata: {{recStep.duration}}</p>
                                                <p>Responsabil 1: {{recStep.firstResponsibleName}}</p>
                                                <p>Responsabil 2: {{recStep.secondResponsibleName}}</p>
                                                <p>Resurse necesare: {{recStep.necessaryResource}}</p>
                                                <p>Observatii: {{recStep.observation}}</p>
                                                <p>Status: {{recStep.status}}</p>
                                            </div>
                                        </mat-step>
                                    </mat-vertical-stepper>

                                </div>
                                <!--end: Form Wizard Step 4-->

                                <!--begin: Form Wizard Step 5-->
                                <div class="pb-5" data-wizard-type="step-content">
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Strategia proiectului</h3>
                                            <p>{{projectData.projectStrategy}}</p>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Atragere candidati</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Canale interne</h5>
                                                <div *ngFor="let internChannel of projectData.internChannel">
                                                    <hr>
                                                    <p>Nume: {{internChannel.name}}</p>
                                                    <p>Cost estimat: {{internChannel.estimatedCost}}</p>
                                                    <p>Cost final: {{internChannel.finalCost}}</p>
                                                    <p>Durata: {{internChannel.time}}</p>
                                                </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Canale externe</h5>
                                            <div *ngFor="let externChannel of projectData.externChannel">
                                                <hr>
                                                <p>Nume: {{externChannel.name}}</p>
                                                <p>Cost estimat: {{externChannel.estimatedCost}}</p>
                                                <p>Cost final: {{externChannel.finalCost}}</p>
                                                <p>Durata: {{externChannel.time}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Testarea si evaluarea candidatilor</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Teste tehnice (interne)</h5>
                                            <div *ngFor="let internalTechnicalTest of projectData.internalTechnicalTest">
                                                <hr>
                                                <p>Nume: {{internalTechnicalTest.name}}</p>
                                                <p>Cost estimat: {{internalTechnicalTest.estimatedCost}}</p>
                                                <p>Cost final: {{internalTechnicalTest.finalCost}}</p>
                                                <p>Durata: {{internalTechnicalTest.time}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Teste tehnice (externe)</h5>
                                            <div *ngFor="let externalTechnicalTest of projectData.externalTechnicalTest">
                                                <hr>
                                                <p>Nume: {{externalTechnicalTest.name}}</p>
                                                <p>Cost estimat: {{externalTechnicalTest.estimatedCost}}</p>
                                                <p>Cost final: {{externalTechnicalTest.finalCost}}</p>
                                                <p>Durata: {{externalTechnicalTest.time}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Teste psihologice ABJ (interne)</h5>
                                            <div *ngFor="let internalPhysiologicalTest of projectData.internalPhysiologicalTest">
                                                <hr>
                                                <p>Nume: {{internalPhysiologicalTest.name}}</p>
                                                <p>Cost estimat: {{internalPhysiologicalTest.estimatedCost}}</p>
                                                <p>Cost final: {{internalPhysiologicalTest.finalCost}}</p>
                                                <p>Durata: {{internalPhysiologicalTest.time}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Teste psihologice ABJ (externe)</h5>
                                            <div *ngFor="let externalPhysiologicalTest of projectData.externalPhysiologicalTest">
                                                <hr>
                                                <p>Nume: {{externalPhysiologicalTest.name}}</p>
                                                <p>Cost estimat: {{externalPhysiologicalTest.estimatedCost}}</p>
                                                <p>Cost final: {{externalPhysiologicalTest.finalCost}}</p>
                                                <p>Durata: {{externalPhysiologicalTest.time}}</p>
                                            </div>
                                        </div>
                                        <div class="col-xl-12">
                                            <h5 class="mt-4">Alte teste</h5>
                                            <div *ngFor="let otherTest of projectData.otherTest">
                                                <hr>
                                                <p>Nume: {{otherTest.name}}</p>
                                                <p>Cost estimat: {{otherTest.estimatedCost}}</p>
                                                <p>Cost final: {{otherTest.finalCost}}</p>
                                                <p>Durata: {{otherTest.time}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-lg-12">
                                            <h3>Recrutori</h3>
                                        </div>
                                        <div class="col-xl-12">
                                            <div *ngFor="let recruiters of projectData.recruiters">
                                                <hr>
                                                <p>Nume: {{recruiters.recruiterName}}</p>
                                                <p>Fee fix: {{recruiters.feeFixed}}</p>
                                                <p>Fee variabil estimat: {{recruiters.feeEstimatedVariable}}</p>
                                                <p>Fee variabil realizat: {{recruiters.feeEstimatedPerformed}}</p>
                                                <p>Bonus fix: {{recruiters.bonusFixed}}</p>
                                                <p>Bonus variabil estimat: {{recruiters.bonusEstimatedVariable}}</p>
                                                <p>Bonus variabil realizat: {{recruiters.bonusEstimatedPerformed}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-10">
                                        <div class="col-xl-12">
                                            <h3>Costuri operationale</h3>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div>
                                                        <p>Deplasari estimat: {{projectData.estimatedTravel}}</p>
                                                        <p>Deplasari realizat: {{projectData.performedTravel}}</p>
                                                        <p>Comunicatii estimat: {{projectData.estimatedCommunication}}</p>
                                                        <p>Comunicatii realizat: {{projectData.performedCommunication}}</p>
                                                        <p>Altele estimat: {{projectData.estimatedOther}}</p>
                                                        <p>Altele realizat: {{projectData.performedOther}}</p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-12">
                                            <h3>TOTAL</h3>
                                            <div class="row">
                                                <div class="col-md-6">
                                                        <p>Total buget estimat: {{projectData.totalEstimatedBudget}}</p>
                                                        <p>Total buget realizat: {{projectData.totalPerformedBudget}}</p>
                                                        <p>Diferenta (estimat - realizat): {{projectData.budgetDiff}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                                <!--end: Form Wizard Step 5-->

                                <!--begin: Form Actions -->
                                <div class="d-flex justify-content-between border-top pt-10">
                                    <div class="mr-2">
                                        <div
                                                class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-prev"
                                        >
                                            Inapoi
                                        </div>
                                    </div>
                                    <div>
                                        <div
                                                class="btn btn-primary font-weight-bold text-uppercase px-9 py-4"
                                                data-wizard-type="action-next"
                                        >
                                            Urmatorul tab
                                        </div>
                                    </div>
                                </div>
                                <!--end: Form Actions -->
                            </form>
                            <!--end: Form Wizard Form-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--end: Wizard -->
    </div>
</div>
